var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.disclaimer)?_c('div',{staticClass:"deposit-disclaimer"},[_c('div',{staticClass:"deposit-disclaimer__line"}),_vm._v(" "),_c('p',{staticClass:"deposit-disclaimer__text"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.disclaimer)}})])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79097934","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/wallet/shared/deposit-disclaimer/deposit-disclaimer.vue
// module id = oyEw
// module chunks = 65